import * as THREE from "three";
import { useMemo } from "react";

/**
 * Creates a canvas texture displaying a room label.
 * Long labels (> 12 chars with multiple words) are split across two lines.
 */
export function useRoomLabel(label: string | undefined): THREE.CanvasTexture | null {
	return useMemo(() => {
		if (!label) return null;
		const canvas = document.createElement("canvas");
		const w = 2048, h = 512;
		canvas.width = w;
		canvas.height = h;
		const ctx = canvas.getContext("2d")!;
		ctx.clearRect(0, 0, w, h);
		ctx.fillStyle = "#ffffff";
		ctx.font = 'bold 220px "Segoe UI", Arial, sans-serif';
		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		const words = label.split(" ");
		if (words.length > 1 && label.length > 12) {
			const mid = Math.ceil(words.length / 2);
			ctx.fillText(words.slice(0, mid).join(" "), w / 2, h / 2 - 110);
			ctx.fillText(words.slice(mid).join(" "), w / 2, h / 2 + 110);
		} else {
			ctx.fillText(label, w / 2, h / 2);
		}
		const texture = new THREE.CanvasTexture(canvas);
		texture.needsUpdate = true;
		return texture;
	}, [label]);
}
